import { app } from "modular-openscriptjs";
import { formatDate } from "../../helpers";
import { dc } from "../../declarations";

const h = app("h");

export default function CapaTransfersView(transfer, type, ...args) {
    let iconClass = "bi bi-arrow-up-right text-danger";
    let bgClass = "bg-danger-subtle";
    let amountSign = "-";
    let amountColor = "text-danger";
    let titleContent = [];

    const actualType = transfer.type || type;

    if (actualType === "transferred") {
        iconClass = "bi bi-arrow-up-right text-danger";
        bgClass = "bg-danger-subtle";
        amountSign = "-";
        amountColor = "text-danger fw-bold";
        titleContent = [
            h.span(
                "Sent to ",
                h.span(`@${transfer.recipient?.username || "unknown"}`, {
                    class: "text-primary fw-bold text-decoration-none",
                }),
            ),
        ];
    } else if (actualType === "received") {
        iconClass = "bi bi-arrow-down-left text-success";
        bgClass = "bg-success-subtle";
        amountSign = "+";
        amountColor = "text-success fw-bold";
        titleContent = [
            h.span(
                "Received from ",
                h.span(`@${transfer.sender?.username || "unknown"}`, {
                    class: "text-primary fw-bold text-decoration-none",
                }),
            ),
        ];
    } else if (actualType === "withdrawn") {
        iconClass = "bi bi-cash-stack text-warning";
        bgClass = "bg-warning-subtle";
        amountSign = "-";
        amountColor = "text-secondary fw-semibold";
        titleContent = [
            h.span(
                "Cash out to M-Pesa",
                h.span(
                    {
                        class: `badge ms-2 rounded-pill ${transfer.status === "completed" ? "bg-success-subtle text-success" : "bg-warning-subtle text-warning"}`,
                    },
                    transfer.status ?? "Status Unknown",
                ),
            ),
        ];
    } else if (actualType === "withdrawal_charge") {
        iconClass = "bi bi-percent text-danger";
        bgClass = "bg-danger-subtle";
        amountSign = "-";
        amountColor = "text-danger fw-semibold";
        titleContent = [
            h.span(
                "Withdrawal Transfer Cost",
                h.span(
                    {
                        class: `badge ms-2 rounded-pill ${transfer.status === "completed" ? "bg-success-subtle text-success" : "bg-warning-subtle text-warning"}`,
                    },
                    transfer.status ?? "Status Unknown",
                ),
            ),
        ];
    }

    return h.div(
        {
            class: "card border-0 shadow-sm rounded-4 p-3 mb-3 d-flex flex-row align-items-center justify-content-between bg-white",
        },
        h.div(
            { class: "d-flex align-items-center gap-3" },
            // Visual Indicator Circle
            h.div(
                {
                    class: `circle d-flex align-items-center justify-content-center ${bgClass}`,
                    style: "width: 48px; height: 48px;",
                },
                h.i({ class: `${iconClass} fs-4` }),
            ),
            h.div(
                h.div(
                    {
                        class: "fw-600 fs-6 text-dark d-flex align-items-center",
                    },
                    ...titleContent,
                ),
                h.div(
                    { class: "text-muted fs-xsm mt-1" },
                    h.span(
                        { class: "fw-500 font-monospace me-2 text-uppercase" },
                        `${transfer.transaction_id || "P-" + transfer.id}`,
                    ),
                    h.span(
                        { class: "opacity-75" },
                        `on ${formatDate(transfer.created_at, "M j, Y at g:i A")}`,
                    ),
                ),
            ),
        ),
        // Amount displays on the right
        h.div(
            { class: `fs-6 text-nowrap ${amountColor}` },
            `${amountSign}${dc.capaSymbol}${transfer.amount}`,
        ),
        ...args,
    );
}
